"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardSkypeOptions_1 = require("./data/mutators/discardSkypeOptions");
var saveSkypeOptions_1 = require("./orchestration/saveSkypeOptions");
var isSkypeOptionDirty_1 = require("./utils/isSkypeOptionDirty");
var SkypeNotificationFull_1 = require("./view/SkypeNotificationFull");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var React = require("react");
var SkypeNotificationOption = {
    key: 'skypeNotifications',
    titleStringKey: 'optionSubcategory_notifications',
    searchTermsStringKey: 'optionSubcategory_notifications',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SkypeNotificationFull_1.default, null); },
        isDirty: isSkypeOptionDirty_1.default,
        onSave: saveSkypeOptions_1.default,
        onDiscard: discardSkypeOptions_1.default,
    },
    isHidden: function () { return !owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-skypeConsumer'); },
};
exports.default = SkypeNotificationOption;
//# sourceMappingURL=SkypeNotificationOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/SkypeNotificationOption.js
// module id = 3372
// module chunks = 2 39